import clsx from "clsx"
import * as s from "./StatCard.style.css"
import type { StatCardProps } from "./StatCard.types"

export type { StatCardProps, StatCardValueColor, StatCardSubLabelVariant } from "./StatCard.types"

export const StatCard = ({
  label,
  value,
  valueColor = "default",
  suffix,
  subLabel,
  subLabelVariant = "muted",
  onSubLabelClick,
  className,
}: StatCardProps) => {
  return (
    <div className={clsx(s.card, className)}>
      <div className={s.label}>{label}</div>

      <div className={s.valueRow}>
        <span className={clsx(s.value, valueColor === "danger" && s.valueDanger)}>
          {value}
        </span>
        {suffix && <span className={s.suffix}>{suffix}</span>}
      </div>

      {subLabel && (
        subLabelVariant === "link" ? (
          <button
            type="button"
            className={s.subLabelLink}
            onClick={onSubLabelClick}
          >
            {subLabel}
          </button>
        ) : (
          <div className={clsx(s.subLabel, {
            [s.subLabelMuted]:    subLabelVariant === "muted",
            [s.subLabelSuccess]:  subLabelVariant === "success",
            [s.subLabelDanger]:   subLabelVariant === "danger",
          })}>
            {subLabel}
          </div>
        )
      )}
    </div>
  )
}
